(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/place-bet/place-bet.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/place-bet/place-bet.js');
"use strict";


const {
  useEffect,
  useRef
} = React;

const usePlaceBet = () => {
  var _svs$core$config$data;
  const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;
  const inProgress = useRef(false);
  useEffect(() => () => {
    inProgress.current = false;
  }, []);

  const placeBet = async _ref => {
    let {
      productId,
      drawData,
      closeCallback,
      wallet,
      raceData,
      isPixMix,
      handleRedirect = () => {},
      setKeepOpenItem = false
    } = _ref;
    if (inProgress.current) {
      return;
    }
    let subProductId;
    if (drawData) {
      subProductId = drawData.subProductId;
    }
    inProgress.current = true;
    const unlockPaymentFlow = () => {
      inProgress.current = false;
    };
    if (isSelfService) {
      await svs.components.sport.quickplayModal.placeBet.placeBetSelfService({
        productId,
        drawData,
        raceData,
        isPixMix,
        closeCallback,
        unlockPaymentFlow
      });
    } else {
      return svs.components.sport.quickplayModal.placeBet.placeBetNewPaymentFlow({
        productId,
        subProductId,
        wallet,
        handleRedirect,
        isPixMix,
        closeCallback,
        unlockPaymentFlow,
        setKeepOpenItem
      });
    }
  };
  return {
    placeBet,
    isPlaceBetInProgress: inProgress.current
  };
};
setGlobal('svs.components.sport.quickplayModal.placeBet.usePlaceBet', usePlaceBet);

 })(window);